import React from "react";
import { observer } from "mobx-react";
import { triggerAnalystCommentModal, getCommentIconRenderingInfo, getInputRenderingInfo, errorExplanationOptions } from '../helpers'
import store from './Stores/SurveyStore';
import { saveValueNew, openPrevYearPanel } from '../control'
import {
    Tooltip,
} from 'react-tippy';
import { isArray } from "highcharts";
import { getSurveyResponseValue, setSurveyResponseValue } from "../Helpers/General/SurveyResponsesHelper";

const SurveyCheckbox = observer((props) => {
    var optionsChecked
    var optionsKeys
    var optionsAvail

    const onClick = (checkbox) => {
        openPrevYearPanel(props.name)
        if (optionsChecked.includes(checkbox)) {
            optionsChecked.splice(optionsChecked.indexOf(checkbox), 1)
        } else {
            optionsChecked.push(checkbox)
        }
        var value = !getValue(checkbox)
        setSurveyResponseValue(checkbox, value, props)
        saveValueNew(checkbox, value, {})

    }

    const getValue = (key) => {
        try {
            if (store.questionMode) {
                return props.name
            } else {
                var value = getSurveyResponseValue(key, props.rowData)
                return value
            }


        } catch (error) {
            return ""
        }

    }


    var commentRenderingInfo = getCommentIconRenderingInfo(props.name)
    var inputRenderingInfo = getInputRenderingInfo(props.name)


    const renderCheckbox = () => {

        // PABS stores options as array
        if (isArray(props.options)) {
            optionsAvail = props.options.filter(function (el) {
                return el != "";
            });
        // IBS stores options as obj
        } else if (typeof props.options === 'object') {
            optionsKeys = Object.keys(props.options)
            optionsAvail = Object.values(props.options)
        }

        optionsChecked = optionsKeys.filter(option => getValue(option) === true)

        const checkboxOptions = optionsAvail.map((option, index) =>
            <React.Fragment>
                <input 
                    type='checkbox' 
                    key={optionsKeys[index]} 
                    name={props.name + " " + option.replace(/\s+/g, '')} 
                    id={props.name + " " + optionsKeys[index]}  
                    checked={optionsChecked.includes(optionsKeys[index])} 
                /> 
                <label htmlFor={props.name + " " + option.replace(/\s+/g, '')} onClick={() => onClick(optionsKeys[index])}>{option}</label>
            </React.Fragment>
        );

        if (store.questionMode) {
            return (<input disabled={true} className={inputRenderingInfo.textClassName + " numInput"} type="text" name={props.name} ></input>)

        }
        return (<div className="col-md-4 v-center-col" className="checkboxDiv"> {checkboxOptions}</div>)

    }


    return (
        <React.Fragment>
            {inputRenderingInfo && inputRenderingInfo.feedbackComment &&
                <Tooltip
                    disabled={store.questionMode}
                    position="top"
                    trigger="mouseenter"
                    animation="fade"
                    delay={250}
                    hideOnClick="false"
                    arrow="true"
                    size="small"
                    interactive="true"
                    html={(
                        <div className="genericTooltip">
                            <span dangerouslySetInnerHTML={{ __html: inputRenderingInfo.feedbackComment }}></span>
                            <br />
                            {errorExplanationOptions(props.name, inputRenderingInfo)}

                        </div>
                    )}
                >

                {renderCheckbox()}
                  
                </Tooltip>
            }

            {!inputRenderingInfo.feedbackComment &&
                renderCheckbox()

            }

            {store.analystMode &&
                <a title={commentRenderingInfo.hoverComment}>&nbsp;&nbsp;&nbsp;<i className={"fa fa-comment " + commentRenderingInfo.className} onClick={() => triggerAnalystCommentModal(props.name)} style={{ visibility: store.analystMode || (store.accountInfo && store.accountInfo.isAnalyst && commentRenderingInfo.className) ? "" : "hidden" }}></i></a>
            }


        </React.Fragment>
    );

});
export default SurveyCheckbox;

